import { Config } from '../core/config'
import CookieHelper from '../../common/helpers/cookieHelper'


const getCuota = () => {
  let cuota = Config.CUOTA;
  let grupo = CookieHelper.readCookie(Config.COOKIE_GRUPO)
    if (Config.SegmentoGroupEnabled && grupo) {
    try {
      cuota = JSON.parse(grupo).quota
    }
    catch (err) { }
  }
  //Leo cuota de configuracion
  //me fijo si tiene grupo
  //si tiene devuelvo la cuota del grupo
  return cuota;
}

export default { getCuota }


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/models/cuota.js